

































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'
import AntecipacaoRecebiveisStore from '../RemuneracaoMedica/financeiro/Store/AntecipacaoRecebiveisStore'

type AttentionMessage = {
  title: string
  subtitle: string
} | null

@Component({ name: 'AntecipacaoProfissionalMock' })
export default class AntecipacaoProfissionalMock extends Vue {
  // DADOS MOCKADOS PARA APRESENTAÇÃO
  requested: number = 15000 // Valor inicial sugerido na barra
  valorOfertado: number = 20000 // Limite de 20k
  interestRate: number = 0.0249 // 2.49%
  dueDate: string = '2025-10-20'
  
  phone: string = '(11) 98765-4321'
  loading: boolean = false

  get getAntecipacaoStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  // Abre/Fecha controlado pela store ou local para a demo
  get getModalAntecipacao() {
    return this.getAntecipacaoStore.showAntecipacaoMock
  }
  set getModalAntecipacao(v: boolean) {
    this.getAntecipacaoStore.setShowAntecipacaoMock(v)
  }

  // Formatação para o input de texto
  get requestedDisplay() {
    return this.requested.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }
  set requestedDisplay(v: string) {
    const val = parseFloat(v.replace(/\./g, '').replace(',', '.'))
    this.requested = isNaN(val) ? 0 : val
  }

  // CÁLCULOS DA DEMO
  get custoAntecipacao(): number {
    return this.requested * this.interestRate
  }

  get recebeHoje(): number {
    return this.requested - this.custoAntecipacao
  }

  get dueDateFmt(): string {
    return "20 de Outubro de 2025"
  }

  toCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
  }

  async handleSubmit() {
    this.loading = true
    
    // Simula um delay de rede para ficar real na apresentação
    await new Promise(resolve => setTimeout(resolve, 1500))
    
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Solicitação enviada com sucesso! O valor será creditado após a confirmação.',
      icon: 'done',
      color: '#2E7D32'
    })
    
    this.loading = false
    this.getModalAntecipacao = false
  }
}
